import {
  AUTH_BOOTSTRAP_SESSION_FAILURE,
  AUTH_BOOTSTRAP_SESSION_REQUEST,
  AUTH_BOOTSTRAP_SESSION_SUCCESS,
  AUTH_CHANGE_PASSWORD_FAILURE,
  AUTH_CHANGE_PASSWORD_REQUEST,
  AUTH_CHANGE_PASSWORD_SUCCESS,
  AUTH_FETCH_ME_FAILURE,
  AUTH_FETCH_ME_REQUEST,
  AUTH_FETCH_ME_SUCCESS,
  AUTH_LOGIN_FAILURE,
  AUTH_LOGIN_REQUEST,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGOUT,
  AUTH_REGISTER_FAILURE,
  AUTH_REGISTER_REQUEST,
  AUTH_REGISTER_SUCCESS,
  AUTH_SETUP_SUPER_ADMIN_FAILURE,
  AUTH_SETUP_SUPER_ADMIN_REQUEST,
  AUTH_SETUP_SUPER_ADMIN_SUCCESS,
  AUTH_SET_LOADING,
  AUTH_SET_USER_PROFILE,
  AUTH_UPDATE_ME_FAILURE,
  AUTH_UPDATE_ME_REQUEST,
  AUTH_UPDATE_ME_SUCCESS,
} from './actionTypes';

export const authActions = {
  setUserProfile: (profile) => ({ type: AUTH_SET_USER_PROFILE, payload: profile }),
  setLoading: (loading) => ({ type: AUTH_SET_LOADING, payload: loading }),
  logout: () => ({ type: AUTH_LOGOUT }),

  bootstrapSessionRequest: (payload, meta) => ({ type: AUTH_BOOTSTRAP_SESSION_REQUEST, payload, meta }),
  bootstrapSessionSuccess: (payload) => ({ type: AUTH_BOOTSTRAP_SESSION_SUCCESS, payload }),
  bootstrapSessionFailure: (payload) => ({ type: AUTH_BOOTSTRAP_SESSION_FAILURE, payload }),

  loginRequest: (payload, meta) => ({ type: AUTH_LOGIN_REQUEST, payload, meta }),
  loginSuccess: (payload) => ({ type: AUTH_LOGIN_SUCCESS, payload }),
  loginFailure: (payload) => ({ type: AUTH_LOGIN_FAILURE, payload }),

  registerRequest: (payload, meta) => ({ type: AUTH_REGISTER_REQUEST, payload, meta }),
  registerSuccess: (payload) => ({ type: AUTH_REGISTER_SUCCESS, payload }),
  registerFailure: (payload) => ({ type: AUTH_REGISTER_FAILURE, payload }),

  fetchMeRequest: (payload, meta) => ({ type: AUTH_FETCH_ME_REQUEST, payload, meta }),
  fetchMeSuccess: (payload) => ({ type: AUTH_FETCH_ME_SUCCESS, payload }),
  fetchMeFailure: (payload) => ({ type: AUTH_FETCH_ME_FAILURE, payload }),

  updateMeRequest: (payload, meta) => ({ type: AUTH_UPDATE_ME_REQUEST, payload, meta }),
  updateMeSuccess: (payload) => ({ type: AUTH_UPDATE_ME_SUCCESS, payload }),
  updateMeFailure: (payload) => ({ type: AUTH_UPDATE_ME_FAILURE, payload }),

  changePasswordRequest: (payload, meta) => ({ type: AUTH_CHANGE_PASSWORD_REQUEST, payload, meta }),
  changePasswordSuccess: (payload) => ({ type: AUTH_CHANGE_PASSWORD_SUCCESS, payload }),
  changePasswordFailure: (payload) => ({ type: AUTH_CHANGE_PASSWORD_FAILURE, payload }),

  setupSuperAdminRequest: (payload, meta) => ({ type: AUTH_SETUP_SUPER_ADMIN_REQUEST, payload, meta }),
  setupSuperAdminSuccess: (payload) => ({ type: AUTH_SETUP_SUPER_ADMIN_SUCCESS, payload }),
  setupSuperAdminFailure: (payload) => ({ type: AUTH_SETUP_SUPER_ADMIN_FAILURE, payload }),
};
